// this supports all possible preline buttons
export default function Button({
  children,
  onClick,
  kind = "solid", // solid, outline, ghost, soft, white, link
  color = "blue", // black, gray, green, blue, red, yellow
  size = "sm", // sm, md, lg
  disabled = false, // bool
  id, // for buttons with labels
  additionalClasses="",
  forceBorder = false
}) {
  const baseClass = `inline-flex items-center gap-x-2 font-semibold text-base rounded-lg disabled:opacity-50 disabled:pointer-events-none focus:outline-none`;
  const sizeClass = {
    sm: "px-3 py-2.5 justify-between",
    md: "px-3 py-4 justify-between",
    lg: "px-5 py-5 justify-between",
    icon: "w-12 h-12 justify-center",
  }[size];
  const kindClass = {
    solid: `text-white ${
      {
        blue: "bg-blue-600 hover:bg-blue-700",
        gray: "bg-gray-600 hover:bg-gray-700",
        green: "bg-green-600 hover:bg-green-700",
        red: "bg-red-600 hover:bg-red-700",
        yellow: "bg-yellow-600 hover:bg-yellow-700",
        black: "bg-gray-800 hover:bg-gray-900",
      }[color]
    }`,
    white: `border border-gray-200 bg-white shadow-2xs hover:bg-gray-50 ${
      {
        blue: "text-blue-500",
        gray: "text-gray-500",
        green: "text-green-500",
        red: "text-red-500",
        yellow: "text-yellow-500",
        black: "text-gray-800",
      }[color]
    }`, //Force border only applicable to select dropdown buttons
    soft: `bg-surface border ${forceBorder ? "border-solid" : "border-transparent"} text-surface-foreground hover:bg-surface-hover focus:outline-hidden focus:bg-surface-hover disabled:opacity-50 disabled:pointer-events-none ${
      {
        blue: "bg-blue-50 text-blue-800 hover:bg-blue-100",
        gray: "bg-gray-50 text-gray-800 hover:bg-gray-100",
        green: "bg-green-50 text-green-800 hover:bg-green-100",
        red: "bg-red-50 text-red-800 hover:bg-red-100",
        yellow: "bg-yellow-50 text-yellow-800 hover:bg-yellow-100",
        black: "bg-gray-800 text-gray-900 hover:bg-gray-900",
        white: "text-gray-900 hover:bg-gray-100"
      }[color]
    }`,
    ghost: `border border-transparent hover:bg-gray-100 ${
      {
        blue: "text-blue-600 hover:text-blue-700",
        gray: "text-gray-600 hover:text-gray-700",
        green: "text-green-600 hover:text-green-700",
        red: "text-red-600 hover:text-red-700",
        yellow: "text-yellow-600 hover:text-yellow-700",
        black: "text-gray-800 hover:text-gray-900",
      }[color]
    }`
  }[kind];

  return (
    <button
      className={`${baseClass} ${sizeClass} ${kindClass} ${additionalClasses}`}
      disabled={disabled}
      onClick={onClick}
      id={id}
    >
      {children}
    </button>
  );
}
